import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useStore from '../store/useStore';
import { useT } from '../i18n';
import Logo from './Logo';

const ADMIN_EMAIL = 'davronking001@gmail.com';

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useStore((s) => s.theme);
  const toggleTheme = useStore((s) => s.toggleTheme);
  const uiLang = useStore((s) => s.uiLang);
  const setUiLang = useStore((s) => s.setUiLang);
  const logout = useStore((s) => s.logout);
  const accessToken = useStore((s) => s.accessToken);
  const userEmail = useStore((s) => s.userEmail);
  const loadUserMe = useStore((s) => s.loadUserMe);
  const t = useT();

  useEffect(() => {
    if (accessToken && !userEmail) loadUserMe();
  }, [accessToken, userEmail, loadUserMe]);

  const isAdmin = userEmail === ADMIN_EMAIL;

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('dashSidebar');
    return saved !== null ? saved === 'open' : true;
  });

  const toggleSidebar = () => {
    const next = !sidebarOpen;
    setSidebarOpen(next);
    localStorage.setItem('dashSidebar', next ? 'open' : 'closed');
  };
  const [profileOpen, setProfileOpen] = useState(false);
  const [logoutConfirm, setLogoutConfirm] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    setLogoutConfirm(true);
    setProfileOpen(false);
  };

  const confirmLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className={`home-page ${theme}`}>

      {logoutConfirm && (
        <div className="confirm-overlay" onClick={() => setLogoutConfirm(false)}>
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="var(--accent)" strokeWidth="2.5" fill="rgba(74,144,217,0.08)" />
                <path d="M20 14h-4a2 2 0 00-2 2v16a2 2 0 002 2h4M28 30l6-6-6-6M18 24h16" stroke="var(--accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              </svg>
            </div>
            <h3 className="confirm-title">{t('profile.logout')}</h3>
            <p className="confirm-desc">{t('profile.logoutConfirm')}</p>
            <div className="confirm-actions">
              <button className="confirm-cancel" onClick={() => setLogoutConfirm(false)}>{t('profile.cancel')}</button>
              <button className="confirm-delete" style={{ background: 'var(--accent)' }} onClick={confirmLogout}>{t('profile.logout')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Top navbar */}
      <nav className="home-nav">
        <Logo size={26} onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        <div className="home-nav-actions">
          <div className="lang-switcher">
            {['EN', 'UZ', 'RU'].map((lang) => (
              <button
                key={lang}
                className={`lang-btn${uiLang === lang.toLowerCase() ? ' active' : ''}`}
                onClick={() => setUiLang(lang.toLowerCase())}
              >
                {lang}
              </button>
            ))}
          </div>
          <button className="menu-icon-btn" onClick={toggleTheme} title="Toggle theme">
            {theme === 'light' ? '\u263E' : '\u2600'}
          </button>
          <div className="profile-wrapper">
            <button className="profile-btn" onClick={() => setProfileOpen(!profileOpen)}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="9" cy="7" r="3" />
                <path d="M3 16c0-3 2.5-5 6-5s6 2 6 5" />
              </svg>
            </button>
            {profileOpen && (
              <>
                <div className="profile-backdrop" onClick={() => setProfileOpen(false)} />
                <div className="profile-menu">
                  <div className="profile-menu-item" onClick={() => { setProfileOpen(false); navigate('/profile'); }}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <circle cx="7.5" cy="5.5" r="2.5" />
                      <path d="M2.5 13c0-2.5 2-4 5-4s5 1.5 5 4" />
                    </svg>
                    {t('profile.profile')}
                  </div>
                  <div className="profile-menu-item" onClick={() => { toggleTheme(); setProfileOpen(false); }}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <circle cx="7.5" cy="7.5" r="3" />
                      <path d="M7.5 1v2M7.5 12v2M1 7.5h2M12 7.5h2M3.1 3.1l1.4 1.4M10.5 10.5l1.4 1.4M3.1 11.9l1.4-1.4M10.5 4.5l1.4-1.4" />
                    </svg>
                    {theme === 'light' ? t('profile.darkMode') : t('profile.lightMode')}
                  </div>
                  <div className="profile-menu-item" onClick={() => { setProfileOpen(false); navigate('/feedback'); }}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <rect x="2" y="2" width="11" height="11" rx="2" />
                      <path d="M5 6h5M5 9h3" />
                    </svg>
                    {t('feedback.menuItem')}
                  </div>
                  <div className="profile-menu-divider" />
                  <div className="profile-menu-item danger" onClick={handleLogout}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M5.5 2H3a1 1 0 00-1 1v9a1 1 0 001 1h2.5M10 10.5l3-3-3-3M6 7.5h7" />
                    </svg>
                    {t('profile.logout')}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Body: sidebar + content */}
      <div className="dash-body">
        <aside className={`dash-sidebar${sidebarOpen ? ' open' : ''}`}>
          <div className="dash-sidebar-header">
            <button className="dash-sidebar-toggle" onClick={toggleSidebar} title={sidebarOpen ? 'Collapse' : 'Expand'}>
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                {sidebarOpen
                  ? <path d="M10 3L5 8l5 5" />
                  : <path d="M6 3l5 5-5 5" />
                }
              </svg>
            </button>
          </div>
          <nav className="dash-sidebar-nav">
            <div className="dash-nav-section">
              <span className="dash-nav-label">{t('sidebar.projects')}</span>
              <button className={`dash-nav-item${isActive('/home') ? ' active' : ''}`} onClick={() => navigate('/home')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="2" width="6" height="6" rx="1.5" />
                  <rect x="10" y="2" width="6" height="6" rx="1.5" />
                  <rect x="2" y="10" width="6" height="6" rx="1.5" />
                  <rect x="10" y="10" width="6" height="6" rx="1.5" />
                </svg>
                <span className="dash-nav-text">{t('sidebar.myProjects')}</span>
              </button>
              <button className={`dash-nav-item${isActive('/templates') ? ' active' : ''}`} onClick={() => navigate('/templates')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="2" width="14" height="14" rx="2" />
                  <path d="M2 7h14M7 7v9" />
                </svg>
                <span className="dash-nav-text">{t('sidebar.chooseTemplate')}</span>
              </button>
              <button className="dash-nav-item new-project" onClick={() => navigate('/editor')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <path d="M9 4v10M4 9h10" />
                </svg>
                <span className="dash-nav-text">{t('sidebar.newProject')}</span>
              </button>
            </div>

            <div className="dash-nav-section">
              <span className="dash-nav-label">{t('sidebar.settings')}</span>
              <button className={`dash-nav-item${isActive('/profile') ? ' active' : ''}`} onClick={() => navigate('/profile')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="9" cy="7" r="3" />
                  <path d="M3 16c0-3 2.5-5 6-5s6 2 6 5" />
                </svg>
                <span className="dash-nav-text">{t('sidebar.profile')}</span>
              </button>
              <button className={`dash-nav-item${isActive('/feedback') ? ' active' : ''}`} onClick={() => navigate('/feedback')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 4a2 2 0 012-2h8a2 2 0 012 2v7a2 2 0 01-2 2H7l-3 3V4z" />
                  <path d="M6 6h6M6 9h3" strokeLinecap="round" />
                </svg>
                <span className="dash-nav-text">{t('sidebar.feedback')}</span>
                <span className="dash-nav-badge">BETA</span>
              </button>
              {isAdmin && (
                <button className={`dash-nav-item${isActive('/admin') ? ' active' : ''}`} onClick={() => navigate('/admin')}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
                    <path d="M9 1.5l6 2.5v4c0 3.5-2.5 6.5-6 8-3.5-1.5-6-4.5-6-8v-4l6-2.5z" />
                    <path d="M6.5 9l2 2 3-3.5" strokeLinecap="round" />
                  </svg>
                  <span className="dash-nav-text">{t('sidebar.admin')}</span>
                </button>
              )}
            </div>
          </nav>
        </aside>

        <main className="dash-main">
          {children}
        </main>
      </div>
    </div>
  );
}
